export enum LocationStatusTypeEnum {
  Active = 1,
  Suspended = 2,
  Deleted = 3,
}
